import React, { ReactNode } from "react";
import styles from "./modal.module.scss";
import ReactModal from "react-modal";
import { ModalProps } from "@/components/modal/base/modal-props";
import Image from "next/image";
import closeIcon from "@/assets/icons/close-icon.svg";

interface Props extends ModalProps {
  children: ReactNode;
  showCloseIcon?: boolean;
}

export const Modal = ({
  isOpen,
  isClosing,
  closeModal,
  children,
  showCloseIcon = true,
}: Props) => {
  if (!isOpen) {
    return null;
  }
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      overlayClassName={`${styles.overlay} ${isClosing ? styles.overlay_fade_out : ""}`}
      className={`${styles.modal} ${isClosing ? styles.modal_fade_out : ""}`}
      ariaHideApp={false}
    >
      {showCloseIcon && (
        <div className={styles.close_icon_wrapper} role="button">
          <Image
            className={styles.close_icon}
            src={closeIcon}
            alt="close"
            onClick={closeModal}
          />
        </div>
      )}
      {children}
    </ReactModal>
  );
};
